import React, { useState, useEffect, useRef } from 'react';
import {
  IconButton,
  InputAdornment,
  TextField,
  Toggle,
  SelectionControlLabel
} from '@one-thd/sui-atomic-components';
import { bool, func, string } from 'prop-types';
import { Duplicate } from '@one-thd/sui-icons';

export const ShareToggle = ({ isShared, listId, onShareToggle }) => {

  const [isCopied, setIsCopied] = useState(false);
  let timeoutID = useRef(null);

  const shareURL = typeof window !== 'undefined'
    && `https://${window.location.hostname}/list/view/details/shared/${listId}`;

  const handleCopyURL = (event) => {
    event.preventDefault();
    navigator.clipboard.writeText(shareURL).then(
      () => {
        setIsCopied(true);
      }
    );
    setTimeout(() => {
      setIsCopied(false);
    }, 3000);
  };

  return (
    <>
      <div className="sui-flex sui-gap-2 sui-mt-6 sui-ml-1">
        <SelectionControlLabel label="Share">
          <Toggle
            checked={isShared}
            onChange={onShareToggle}
            inputAttributes={{ 'aria-label': 'share-toggle' }}
            disabled={isCopied}
          />
        </SelectionControlLabel>
      </div>
      <div className="sui-flex sui-gap-2 sui-mb-3">
        <TextField
          disabled={!isShared}
          fullWidth
          value={shareURL || ''}
          helpMessage={isShared && !isCopied ? 'Copy this link to share' : ''}
          statusMessage={isCopied ? 'Copied!' : ''}
          status={isCopied ? 'success' : null}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="Copy"
                  icon={Duplicate}
                  onClick={handleCopyURL}
                />
              </InputAdornment>
            ),
            'aria-label': 'Copy'
          }}
        />
      </div>
    </>
  );
};

ShareToggle.propTypes = {
  isShared: bool,
  onShareToggle: func,
  listId: string.isRequired,
};

ShareToggle.defaultProps = {
  isShared: true,
  onShareToggle: () => {},
};
